import React, { useState, useEffect } from "react";
import Radio from "../../Forms/Radio";
import CONSTANTS from "../../../constants";
import CheckBox from "../../Forms/CheckBox";
import { connect } from "react-redux";

const mapStateToProps = (state) => state;

const ForfaitRevisionItemFlex = (props) => {
  const [selectedForfait, setSelectedForfait] = useState("");
  const [showItemDetails, setShowItemDetails] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const currencyPlacement = !!Number(window.siteConfig.PoundPlacement);
  const forfait = props.data;

  const updatePrice = () => {
    let totalPrice = props.data.Items[0].Prix;
    if (props.data.Operations != null)
      props.data.Operations.map(function(operation) {
        if (operation.isSelected) totalPrice += operation.Items[0].Prix;
      });
    props.setTotalPrice(totalPrice);
  };

  useEffect(() => {
    let totalPrice = props.data.Items[0].Prix;
    if (props.data.Operations != null)
      props.data.Operations.map(function(operation) {
        if (operation.isSelected) totalPrice += operation.Items[0].Prix;
      });
    props.setTotalPrice(totalPrice);
  }, []);

  const getFinalPrice = (priceToDisplay) =>
    currencyPlacement ? (
      <span>
        {CONSTANTS.LABELS.common_v2_currency +
          priceToDisplay +
          ` ${CONSTANTS.LABELS.needs_basket_label2}`}
      </span>
    ) : (
      <span>
        {priceToDisplay +
          ` ${CONSTANTS.LABELS.common_v2_currency}` +
          ` ${CONSTANTS.LABELS.needs_basket_label2}`}
      </span>
    );

  return (
    <React.Fragment>
      <div
        className={
          props.index === 0
            ? "forfaitRevisionItemContainer isFirst"
            : "forfaitRevisionItemContainer isNotFirst"
        }
      >
        <div className="forfaitRevisionChoiceContainer">
          <Radio
            label={forfait.Libelle}
            id={forfait.Items[0].Ref}
            value={forfait.Items[0].Ref}
            name={props.familyCode}
            onChange={(e) => {
              updatePrice();
              setSelectedForfait(e.target.value);
              props.updateSelectedForfait(
                e.target.checked,
                forfait.Items[0].Ref
              );
              props.enableAddButton(e.target.checked);
            }}
            isChecked={props.data.isSelected}
            customLabelStyle={{
              fontSize: window.isMobile() === "desktop" ? "16px" : "14px",
              color:
                props.data.isSelected && CONSTANTS.SITE_INFO.BRAND_CODE === "C"
                  ? "#57718a"
                  : CONSTANTS.SITE_INFO.BRAND_CODE === "C"
                  ? "#000000"
                  : undefined,
              marginLeft: window.isMobile() === "desktop" ? "8px" : "0px",
            }}
          />

          {!!forfait.Comments.length && (
            <div className="iconContainer">
              <span
                className={
                  showComments
                    ? "revisionIconInfo isClicked"
                    : "revisionIconInfo"
                }
                onClick={() => {
                  setShowComments(!showComments);
                }}
              ></span>
              {showComments && (
                <div className="revisionPopup">
                  {typeof forfait.Comments === "object" &&
                    forfait.Comments.length &&
                    forfait.Comments.map(function(item, key) {
                      return (
                        <span key={key}>
                          {key + 1} - {item.Text}
                          <br />
                        </span>
                      );
                    })}
                  {typeof forfait.Comments === "string" &&
                    forfait.Comments.length && (
                      <span>
                        {forfait.Comments} <br />
                      </span>
                    )}
                </div>
              )}
            </div>
          )}
        </div>

        {props.data.isSelected && (
          <div>
            <div className="forfaitContentTitle1">
              {CONSTANTS.LABELS.needs_basket_maintenance_label6}
            </div>

            <div className="forfaitLigneContainer">
              <div className="forfaitLigneSubContainer">
                <div>{forfait.Libelle}</div>

                {!!forfait.Comments.length && (
                  <div className="iconContainer">
                    <span
                      className={
                        showItemDetails &&
                        showItemDetails === forfait.Items[0].Ref
                          ? "revisionIconInfo isClicked"
                          : "revisionIconInfo"
                      }
                      onClick={() =>
                        showItemDetails !== forfait.Items[0].Ref
                          ? setShowItemDetails(forfait.Items[0].Ref)
                          : setShowItemDetails(false)
                      }
                    ></span>
                    {showItemDetails &&
                      showItemDetails === forfait.Items[0].Ref && (
                        <div className="revisionPopup">
                          {typeof forfait.Comments === "object" &&
                            forfait.Comments.map(function(item, key) {
                              return (
                                <span key={"comment-" + key}>
                                  {key + 1} - {item.Text}
                                  <br />
                                </span>
                              );
                            })}
                          {typeof forfait.Comments === "string" && (
                            <span>
                              {forfait.Comments} <br />
                            </span>
                          )}
                        </div>
                      )}
                  </div>
                )}
              </div>

              {/* prix Socle de base */}
              <div className="forfaitLignePriceContainer">
                {props.store.booking.happy && (
                  <div className="discountPriceItem">
                    {getFinalPrice(forfait.Items[0].Prix)}
                  </div>
                )}

                <div className="forfaitLignePrice">
                  {!!Number(props.store.booking.happy)
                    ? getFinalPrice(
                        (
                          forfait.Items[0].Prix -
                          forfait.Items[0].Prix *
                            0.01 *
                            props.store.booking.happy
                        ).toFixed(2)
                      )
                    : getFinalPrice(forfait.Items[0].Prix)}
                </div>

                {props.store.booking.happy && (
                  <div className="discountRate">{`${props.store.booking.happy}%`}</div>
                )}
              </div>
            </div>

            <div className="separatorRevision"></div>

            {forfait.Operations !== null && (
              <React.Fragment>
                <div className="complementaryOperationsContainer">
                  <div
                    className="complementaryOperationsTitle"
                    dangerouslySetInnerHTML={{
                      __html: CONSTANTS.LABELS.needs_basket_maintenance_label7,
                    }}
                  ></div>

                  <div
                    className="complementaryOperationsSubTitle"
                    dangerouslySetInnerHTML={{
                      __html: CONSTANTS.LABELS.needs_basket_maintenance_label8,
                    }}
                  ></div>
                </div>

                {forfait.Operations.map((operation, keyopp) => (
                  <div key={keyopp} className="complementaryOpItemsContainer">
                    <div className="complementaryOpItemTitle">
                      <CheckBox
                        label={operation.Libelle}
                        id={operation.Items[0].Ref}
                        isChecked={operation.isSelected}
                        customLabelStyle={{
                          color:
                            operation.isSelected &&
                            CONSTANTS.SITE_INFO.BRAND_CODE === "C"
                              ? "#57718a"
                              : CONSTANTS.SITE_INFO.BRAND_CODE === "C"
                              ? "#3b3938"
                              : undefined,
                          marginLeft:
                            window.isMobile() === "desktop" ? "16px" : "0px",
                          fontSize:
                            window.isMobile() === "desktop" ? "16px" : "14px",
                        }}
                        onClick={(e) => {
                          props.updateSelectedOperation(
                            e.target.checked,
                            operation.Items[0].Ref
                          );
                          if (e.target.checked) {
                            props.setTotalPrice(
                              props.TotalPrice + operation.Items[0].Prix
                            );
                          } else {
                            props.setTotalPrice(
                              props.TotalPrice - operation.Items[0].Prix
                            );
                          }
                        }}
                      />

                      {!!forfait.Comments.length && (
                        <div className="iconContainer">
                          <span
                            className={
                              showItemDetails &&
                              showItemDetails === operation.Items[0].Ref
                                ? "revisionIconInfo isClicked"
                                : "revisionIconInfo"
                            }
                            onClick={() =>
                              showItemDetails !== operation.Items[0].Ref
                                ? setShowItemDetails(operation.Items[0].Ref)
                                : setShowItemDetails(false)
                            }
                          ></span>
                          {showItemDetails &&
                            showItemDetails === operation.Items[0].Ref && (
                              <div className="revisionPopup">
                                {typeof operation.Comments === "object" &&
                                  operation.Comments.map(function(item, key) {
                                    return (
                                      <span key={"comment-" + key}>
                                        {key + 1} - {item.Text}
                                        <br />
                                      </span>
                                    );
                                  })}
                                {typeof operation.Comments === "string" && (
                                  <span>
                                    {operation.Comments} <br />
                                  </span>
                                )}
                              </div>
                            )}
                        </div>
                      )}
                    </div>

                    <div className="complementaryOpItemPriceContainer">
                      {props.store.booking.happy && (
                        <div className="discountPriceItem">
                          {getFinalPrice(operation.Items[0].Prix)}
                        </div>
                      )}
                      <div
                        className={
                          operation.isSelected
                            ? "complementaryOpItemPrice isSelected"
                            : "complementaryOpItemPrice"
                        }
                      >
                        {props.store.booking.happy
                          ? getFinalPrice(
                              (
                                operation.Items[0].Prix *
                                0.01 *
                                (100 - props.store.booking.happy)
                              ).toFixed(2)
                            )
                          : getFinalPrice(operation.Items[0].Prix)}
                      </div>

                      {props.store.booking.happy && (
                        <div className="discountRate">{`${props.store.booking.happy}%`}</div>
                      )}
                    </div>
                  </div>
                ))}
              </React.Fragment>
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(ForfaitRevisionItemFlex);
